module.exports = __webpack_public_path__ + "img/nike_air-one.f9d21a9a.jpeg";